import { gql } from 'graphql-request';

export const DELETE_INVITE_USER_SEARCH_QUERY = gql`
  mutation DeleteInviteUserSearch($uuid: ID!) {
    deleteInviteUserSearch(input: { uuid: $uuid }) {
      status
    }
  }
`;
